// @ts-expect-error not migrated to TS yet

// @ts-expect-error not migrated to TS yet
import { getHasAccessToAutomationTabOnly } from 'EmailData/selectors/details/authSelectors';
import ContentRoutes from 'ContentUtils/Routes';
import { getIsDragDropEmail, getIsLeadflowEmail } from './emailStateUtil';
export const getEmailEditPath = email => {
  if (getIsLeadflowEmail(email)) {
    return ContentRoutes.formFollowup(email.formId);
  } else if (getIsDragDropEmail(email)) {
    return ContentRoutes.editDragDropEmail(email.id);
  } else {
    return ContentRoutes.edit(email.id, email.categoryId);
  }
};
export const getEmailPathById = (emailId, email = null, state) => {
  if (email !== null && getIsLeadflowEmail(email)) {
    return ContentRoutes.formFollowup(email.formId);
  } else if (email !== null && getIsDragDropEmail(email)) {
    if (getHasAccessToAutomationTabOnly(email)(state)) {
      return ContentRoutes.editEmailAutomation(email.id);
    } else {
      return ContentRoutes.editDragDropEmail(email.id);
    }
  } else {
    if (getHasAccessToAutomationTabOnly(email)(state)) {
      return ContentRoutes.editEmailAutomation(email.id);
    } else {
      return ContentRoutes.edit(email.id, email.categoryId);
    }
  }
};